import React from 'react';

const Mission: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-primary text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Notre Mission</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Partager l'amour de Jésus-Christ à travers l'évangélisation et les œuvres sociales
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-6">Notre mission</h2>
              <p className="text-xl mb-8">
                La mission de More Love se résume ainsi :
              </p>
              <blockquote className="text-2xl mb-8">
                « Partager l'amour de Jésus-Christ à travers l'évangélisation et les œuvres sociales 
                pour le bien être de la femme et de l'enfant »
              </blockquote>
            </div>

            <div className="mb-12">
              <h2 className="text-3xl font-bold mb-6 text-center">Notre vision</h2>
              <p className="mb-4">
                Notre vision est de créer un monde où les femmes et les enfants sont valorisés, 
                protégés et habilités à atteindre leur plein potentiel. Nous croyons que chaque 
                personne mérite dignité, respect et opportunités, indépendamment de sa situation.
              </p>
              <p className="mb-4">
                Nous aspirons à être un phare d'espoir et un catalyseur de changement positif 
                dans les communautés que nous servons, en démontrant l'amour du Christ à travers 
                nos actions et notre engagement.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-3xl font-bold mb-6 text-center">Nos valeurs</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="card">
                  <h3 className="text-xl font-bold mb-3 text-primary">Amour</h3>
                  <p>
                    L'amour est au cœur de tout ce que nous faisons, reflétant l'amour 
                    inconditionnel de Christ pour tous.
                  </p>
                </div>
                <div className="card">
                  <h3 className="text-xl font-bold mb-3 text-primary">Compassion</h3>
                  <p>
                    Nous agissons avec compassion, reconnaissant la dignité inhérente à 
                    chaque personne que nous servons.
                  </p>
                </div>
                <div className="card">
                  <h3 className="text-xl font-bold mb-3 text-primary">Intégrité</h3>
                  <p>
                    Nous maintenons les plus hauts standards d'intégrité dans toutes nos 
                    actions et décisions.
                  </p>
                </div>
                <div className="card">
                  <h3 className="text-xl font-bold mb-3 text-primary">Excellence</h3>
                  <p>
                    Nous nous efforçons d'exceller dans tous nos programmes et services, 
                    honorant Dieu par notre travail.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-3xl font-bold mb-6 text-center">Notre engagement</h2>
              <p className="mb-4">
                Nous nous engageons à travailler sans relâche pour améliorer la vie des femmes 
                et des enfants, en leur offrant soutien, ressources et opportunités pour un 
                avenir meilleur.
              </p>
              <p className="mb-8">
                Notre travail est guidé par notre foi et notre conviction que l'amour de Christ 
                peut transformer des vies et des communautés entières.
              </p>
              <blockquote className="text-xl text-center my-8">
                « Le Seigneur dit une parole et les messagères de bonnes nouvelles sont une grande armée »
                <footer className="mt-2">Psaumes 68:12</footer>
              </blockquote>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-light">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Rejoignez notre mission</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Ensemble, nous pouvons faire une différence significative dans la vie des femmes et des enfants.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href="/donate" className="btn-donate">Faire un don</a>
            <a href="/membership" className="btn-primary">Devenir membre</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Mission;
